import Cookie from 'js-cookie';

import 'source/global';
import {
    loadCommonMenu,
    loadGtm,
    loadLanguage,
    loadScript,
    loadStyle,
    loadVwo,
    loadOneTrust,
} from 'source/lib/loaders';
import Settings from 'source/lib/settings_model';

import FooterView from './parts/footer';
import IDRouter from './router';

function isAuthenticated() {
    const cookieName = Settings.get('App.IsAuthenticatedCookieName');
    return Cookie.get(cookieName) === 'yes';
}

async function initialize() {
    await Settings.startSync();
    document.documentElement.lang = Settings.get('General.LanguageCode');

    await Promise.all([
        loadScript(`${Settings.get('App.StaticUrl')}l10n/plugins/moment/moment.js`)
            .catch(() => {
                window.moment = () => ({
                    format() {
                        return '';
                    },
                });
            })
            .then(() => loadLanguage()),
        loadCommonMenu(),
        loadStyle(Settings.get('App.StaticUrl'),
            Settings.get('Realm.FeatureRealm') || Settings.get('Realm.CurrentRealm')),
    ]);

    await loadOneTrust(Settings.get('General.OneTrust'));
    loadVwo();
    loadGtm(Settings.get('General.GoogleTagManager'), isAuthenticated());

    document.querySelector('#common_menu').classList.remove('hidden');

    const stagingInfo = Settings.get('Request.StagingInfo');
    const stagingInfoElement = document.querySelector('#staging-info');
    const logoLink = document.querySelector('.js-header-content a');

    if (stagingInfo) {
        stagingInfoElement.innerHTML = stagingInfo;
    }
    logoLink.setAttribute('href', Settings.get('Realm.UrlLogoLink'));

    document.querySelector('.js-header').style.display = '';
    const router = new IDRouter();

    const footerView = new FooterView({
        el: '#js-footer',
        router,
    });
    return { router, footerView };
}

import('wg-riddler' /* webpackChunkName: "riddler" */)
    .then(module => {
        window.Riddler = module.default;
        return initialize();
    }).catch(
        (err) => {
            console.error(err);
        },
    );
